const EDIT_TYPE = {
    EDIT: 2,
    CANCEL: -3
};

export const config = {
    name: 'localCustomerManager',
    selection: false,
    index: false,
    height: 300,
    columns: [
        {
            label: '分公司',
            prop: 'companyName',
            type: 'advance',
            name: '添加分公司',
            value: 'companyName',
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称' }
            ],
            highlightCurrentRow: true,
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            mustFill: true,
            hideTooltip: true,
            width: 200
        },
        {
            label: '属地客户经理名称',
            prop: 'localManagerName',
            type: 'advanceUser',
            name: '添加属地客户经理',
            mustFill: true,
            width: 200
        },
        {
            label: '属地客户经理MIP',
            prop: 'localManagerCode',
            width: 120
        },
        {
            label: '用户状态',
            prop: 'localManagerStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LOCAL_MANAGER_STATUS',
            width: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 150
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 150
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 100, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '废弃',
                event: 'abandon',
                displayRule: (row) => {
                    return +row.edit === EDIT_TYPE.CANCEL;
                }
            }
        ]
    },
    rowEdit: true,
    rowDbClickFun: (row) => false, // 是否双击编辑
    disableEditFun: (row) => false // 编辑按钮禁用
};
